<template>
  <div
    v-if="showControls"
    class="controls"
    :class="alignmentClass"
  >
    <sh-button
      v-if="!isEditMode && cta1Href"
      class="cta"
      :[btnLinkKeyCTA1]="cta1Href"
      :target="cta1Target"
      :aria-label="cta1HiddenText || cta1Title"
      :[setStyleCTA1]=true
      :themeOverride="themeOverride"
    >
      {{ cta1Text }}
    </sh-button>
    <sc-link v-if="isEditMode" class="cta" :field="cta1 || {}"/>
    <sh-button
      v-if="!isEditMode && cta2Href"
      class="cta"
      :[btnLinkKeyCTA2]="cta2Href"
      :target="cta2Target"
      :aria-label="cta2HiddenText || cta2Title"
      :[setStyleCTA2]="true"
      :themeOverride="themeOverride"
    >
      {{ cta2Text }}
    </sh-button>
    <sc-link v-if="isEditMode" class="cta" :field="cta2 || {}"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Link } from '@sitecore-jss/sitecore-jss-vue'
import ALIGNMENT from '~/constants/alignment'
import { getButtonType } from '~/helpers/get-button-type'
import mapFields from '~/helpers/map-fields'
import getButtonStyle from '~/helpers/get-button-style'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'EditorialCta',

  components: {
    ScLink: Link
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    desktopAlignment: {
      type: String,
      default: ALIGNMENT.LEFT,
      validator: value => Object.values(ALIGNMENT).includes(value)
    },
    usePlainButtons: {
      type: Boolean,
      default: false
    },
    themeOverride: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapFields({
      cta1: 'cta1',
      cta2: 'cta2',
      cta1Href: 'cta1.value.href',
      cta2Href: 'cta2.value.href',
      cta1Appearance: 'cta1Appearance.value',
      cta2Appearance: 'cta2Appearance.value',
      cta1Target: 'cta1.value.target',
      cta2Target: 'cta2.value.target',
      cta1Text: 'cta1.value.text',
      cta2Text: 'cta2.value.text',
      cta1Title: 'cta1.value.title',
      cta2Title: 'cta2.value.title',
      cta1HiddenText: 'cta1.value.data-hidden-text',
      cta2HiddenText: 'cta2.value.data-hidden-text'
    }),

    showControls () {
      return this.isEditMode || this.cta1Href || this.cta2Href
    },

    btnLinkKeyCTA1 () {
      if (this.usePlainButtons) return ''
      return getButtonType(this.cta1Href)
    },

    btnLinkKeyCTA2 () {
      if (this.usePlainButtons) return ''
      return getButtonType(this.cta2Href)
    },

    alignmentClass () {
      return `desktop-align-${this.desktopAlignment}`.toLowerCase()
    },

    setStyleCTA1 () {
      return getButtonStyle(this.cta1Appearance)
    },

    setStyleCTA2 () {
      return getButtonStyle(this.cta2Appearance)
    }
  }
}
</script>

<style lang="scss" scoped>
.controls {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: $space-060;

  @include tablet {
    flex-direction: row;
  }

  &.desktop-align-center {
    @include tablet {
      justify-content: center;
      align-items: center;
    }
  }

  .cta {
    @include stack-space($space-050);

    @include tablet {
      @include stack-space(0);
      @include inline-space($space-060);
    }
  }
}
</style>
